<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in icon="Q" :title="title"></SectionTitle>
    <QuestionBox :title="questionTitle" :desc="questionDesc" :items="questionItem" :index="questionAnswer" v-on:selected="selected"></QuestionBox>
    <GoNext class="animate-target" v-animate-in href="/section1/1-5" :selected="selectedValue" required="true">Submit</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt" />
  </div>
</template>

<script>
import QuestionBox from "../../components/QuestionBox";
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
export default {
  name: "s1-4",
  components: {SectionTitle, QuestionBox, GoNext, ContentNotice},
  data(){
    return {
      questionTitle: "Question 4",
      questionDesc: "Finerenone may be recommended for people with T2D and CKD who have:",
      questionItem:[
        "Serum [K+] ≤4.8 mmol/L and eGFR ≥25 mL/min/1.73 m<sup>2</sup>",
        "Serum [K+] >5.0 mmol/L and eGFR <25 mL/min/1.73 m<sup>2</sup>",
        "Serum [K+] >5.0 mmol/L and eGFR ≥25 mL/min/1.73 m<sup>2</sup>",
        "None of the above"
      ],
      selectedValue:'',
      noticeTxt:"CKD, chronic kidney disease; CV, cardiovascular disease; eGFR, estimated glomerular filtration rate; K+, patassium ion.",
      questionAnswer:'0',
      title:'Pre-activity quiz'
    }
  },
  methods:{
    selected:function(value){
      this.selectedValue = value;
    }
  }
}
</script>

<style scoped>

</style>
